require('intersection-observer');

import Page from './components/Page';
import Side from './components/Side';
//import Sketch from './components/Sketch';
import Gallery from './components/Gallery';
import Photos from './components/Photos';
import BgMusic from './components/BgMusic';
import getScrollbarWidth from './components/getScrollbarWidth';

import LazyLoad from "vanilla-lazyload";
import lazyLoadInstances from "./components/LazyInstances";

var test ="";

document.addEventListener('DOMContentLoaded', function(){
    if(/iPad|iPhone|iPod|Macintosh|MacIntel|MacPPC|Mac68K/.test(navigator.userAgent) && !window.MSStream){
        document.body.classList.add('_ios');
    }
    if(navigator.userAgent.toLowerCase().indexOf("android") > -1) {
        document.body.classList.add('_android');
    }
    if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
        document.body.classList.add('_firefox');
    }

    let w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
    let h = parseFloat(Math.max(document.documentElement.clientHeight, window.innerHeight || 0),0);
    window.addEventListener('resize', function(){
        w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
        h = parseFloat(Math.max(document.documentElement.clientHeight, window.innerHeight || 0),0);
        if(h/w > 0.5625){
            document.body.classList.add('_wide');
        }
        else{
            document.body.classList.remove('_wide');
        }
    });

    const pages = document.getElementsByClassName('j-page');
    for(let i=0; i<pages.length; i++){
        new Page(pages[i]);
    }

    const sides = document.getElementsByClassName('j-side');
    for(let i=0; i<sides.length; i++){
        new Side(sides[i]);
    }

    // const sketches = document.getElementsByClassName('j-gl');
    // for(let i=0; i<sketches.length; i++){
    //     new Sketch(sketches[i].getAttribute('id'));
    // }

    new BgMusic(document.getElementById('bg-music'));

    const pageContent = document.getElementsByClassName('j-page-content');
    for(let i=0; i<pageContent.length; i++){
        pageContent[i].style.width = `calc(100vw + ${getScrollbarWidth()}px)`;
    }

    const sideContent = document.getElementsByClassName('j-side');
    for(let i=0; i<sideContent.length; i++){
        sideContent[i].style.width = `calc(44vw + ${getScrollbarWidth()}px)`;
        sideContent[i].style.marginRight = `-${getScrollbarWidth()}px`;
    }

    const galleries = document.getElementsByClassName('j-gallery');
    for(let i=0; i<galleries.length; i++){
        new Gallery(galleries[i]);
    }

    const photos = document.getElementsByClassName('j-photo');
    for(let i=0; i<photos.length; i++){
        new Photos(photos[i]);
    }

    let scrollCounter = 0;
    var flag = true;
    document.addEventListener('scrolling.init', function(){
        function detectScrolling(e){
            //console.log(e.path[e.path.length - 5].classList.contains('side'))
            if(document.querySelector('.side._opened')){
                if(!e.path[e.path.length - 5].classList.contains('side') && flag){
                    flag = false;
                    document.dispatchEvent(new Event('side.close'));
                    setTimeout(function(){flag = true}, 1000) ;
                }
            }
            if(!document.body.classList.contains('_sided')){
                if(document.getElementsByClassName('_current')[0].getElementsByClassName('j-page-content').length < 1){
                    if((((e.deltaY || -e.wheelDelta || e.detail) >> 10) || 1) > 0){
                        if(scrollCounter < 0){
                            scrollCounter = 0;
                        }
                        scrollCounter++;                    
                    }
                    else{
                        if(scrollCounter > 0){
                            scrollCounter = 0;
                        }
                        scrollCounter--;
                    }
                    if(scrollCounter > 100){
                        //document.dispatchEvent(new CustomEvent('page.change', {'detail': {'current': document.getElementsByClassName('_current')[0].getAttribute('data-id'), 'direction': 'next'}}));
                        scrollCounter = 0;
                    }
                    if(scrollCounter < -5){
                        //document.dispatchEvent(new CustomEvent('page.change', {'detail': {'current': document.getElementsByClassName('_current')[0].getAttribute('data-id'), 'direction': 'prev'}}));
                        scrollCounter = 0;
                    }
                }
                else{
                    let scroller = document.getElementsByClassName('_current')[0].getElementsByClassName('j-page-content')[0];
                    let scrollerInner = document.getElementsByClassName('_current')[0].getElementsByClassName('j-page-content-inner')[0];
                    let h = parseFloat(Math.max(document.documentElement.clientHeight, window.innerHeight || 0),0);
                    let scrollTop = scroller.scrollTop;
                    // console.log(scrollerInner.clientHeight);
                    // console.log(h+scrollTop);
                    //console.log(e.deltaY, -e.wheelDelta, e.detail)
                    if(scrollerInner.clientHeight <= h+scrollTop){
                        if((((e.deltaY || -e.wheelDelta || e.detail) >> 10) || 1) > 0){
                            if(document.querySelector('._current .day-to-prev-desk')){
                                document.querySelector('._current .day-to-prev-desk').style = "transform: translateY(-150px)"
                            }
                            if(scrollCounter < 0){
                                //scrollCounter = 0;
                            }
                            scrollCounter++;                    
                        }
                        if(scrollCounter > 0){
                            //document.dispatchEvent(new CustomEvent('page.change', {'detail': {'current': document.getElementsByClassName('_current')[0].getAttribute('data-id'), 'direction': 'next'}}));
                            //scrollCounter = 0;
                        }
                    }
                    if(scrollTop === 0){
                        if((((e.deltaY || -e.wheelDelta || e.detail) >> 10) || 1) <= 0){
                            if(scrollCounter > 0){
                                //scrollCounter = 0;
                                
                            }
                            scrollCounter--;
                        }
                        if(scrollCounter < -1){
                            //document.dispatchEvent(new CustomEvent('page.change', {'detail': {'current': document.getElementsByClassName('_current')[0].getAttribute('data-id'), 'direction': 'prev'}}));
                            if(document.querySelector('._current .day-to-prev-desk')){
                                document.querySelector('._current .day-to-prev-desk').style = "transform: translateY(0)"
                            }
                            //scrollCounter = 0;
                        }
                    }
                    else{
                        if(document.querySelector('._current .day-to-prev-desk')){
                            document.querySelector('._current .day-to-prev-desk').style = "transform: translateY(-150px)"
                        }
                    }
                }
            }
        };
        document.addEventListener("wheel", detectScrolling);
        document.addEventListener("mousewheel", detectScrolling);
        document.addEventListener("DOMMouseScroll", detectScrolling);
    });

    new LazyLoad({
        elements_selector: ".j-lazy-zone",
        load_delay: 100,
        callback_enter: function(el) {
            let oneLL = new LazyLoad({
                elements_selector: ".lazy",
                container: el,
                load_delay: 100
            });
            lazyLoadInstances.push(oneLL);
        }
    });

    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)){
        let vid = document.getElementsByClassName('j-video');
        for(let i=0; i<vid.length; i++){
            vid[i].getElementsByTagName('video')[0].removeAttribute('controls');
            vid[i].getElementsByTagName('video')[0].classList.add('_with-play');
        }

        let svid = document.getElementsByClassName('j-small-video');
        for(let i=0; i<svid.length; i++){
            svid[i].getElementsByTagName('video')[0].removeAttribute('controls');
            svid[i].getElementsByTagName('video')[0].classList.add('_with-play');
        }

        let sidevid = document.getElementsByClassName('j-side-video');
        for(let i=0; i<sidevid.length; i++){
            sidevid[i].getElementsByTagName('video')[0].removeAttribute('controls');
            sidevid[i].getElementsByTagName('video')[0].classList.add('_with-play');
        }

        let vidPlay = document.getElementsByClassName('j-vid-play');
        for(let i=0; i<vidPlay.length; i++){
            vidPlay[i].addEventListener('click', function(){
                if(vidPlay[i].classList.contains('_pause')){
                    vidPlay[i].closest('div').getElementsByTagName('video')[0].pause();
                    vidPlay[i].classList.remove('_pause');
                }
                else{
                    vidPlay[i].closest('div').getElementsByTagName('video')[0].play();
                    vidPlay[i].classList.add('_pause');
                }
            });
        }
    }

    document.querySelector(".day--7-2").addEventListener("mousemove", parallax);
    const elem = document.querySelectorAll(".day--7-2 .day-bg")[1];
    function parallax(e) {
        let _w = window.innerWidth/2;
        let _mouseX = e.clientX;
        let _depth2 = `${1 - (_mouseX - _w) * 0.02}px`;
        elem.style.transform = "translate("+_depth2+", 0px) scaleX(1.08)";
		//console.log(_depth2)
    }

    let vidPlay = document.getElementsByClassName('j-vid-play');
    for(let i=1; i<vidPlay.length; i++){
        vidPlay[i].classList.add("show_play")
        vidPlay[i].addEventListener('click', function(){
            var player = videojs(vidPlay[i].parentElement.children[1].id)
            if(vidPlay[i].classList.contains('_pause')){
                player.pause();
                vidPlay[i].classList.remove('_pause');
            }
            else{

                player.play();
                vidPlay[i].style ="display: none;";
                document.querySelector('#smallVideo2 .j-vid-play').parentElement.parentElement.querySelector('.px-video-controls').style='transform: translateZ(0);';
                document.querySelector('#smallVideo2 .j-vid-play').parentElement.parentElement.querySelector('.day-small-video__buy').style='transform: translateZ(0);';
            }
        });
    }
    

    document.dispatchEvent(new Event('loading.complete'));
});